// extracted by mini-css-extract-plugin
export default {"App":"App_App__FELDB","table":"App_table__ta5N3"};